import { UrlApi } from "../../../../../../../services/apirest";

export const getCuentaCorrientePendientes = async (
  idCliente,
  idTipoNegocio,
) => {
  const response = await fetch(
    `${UrlApi}/comprobantes/ledger/soloPendientes/${idCliente}/${idTipoNegocio}`,
  );

  if (!response.ok)
    throw new Error("Error al obtener los documentos pendientes");

  return await response.json();
};
